module.exports = __webpack_public_path__ + "img/logo2.60a8cda7.png";